import axios from 'axios'
import jsonpAdapter from 'axios-jsonp'
import filterAlbums from './filterAlbumsToShow'

// For Test DEV BUSINESS ID
const DEV_BUSINESS_ID = ''
// const DEV_BUSINESS_ID = 'bzn-T2vOUVwXQ-SvOoeuX64BGA'
const DEV_API_BASE = 'https://maindiscovery.dev.gonation.com'
const PRODUCTION_API_BASE = 'https://data.gonation.com'
const APIBASE = DEV_BUSINESS_ID ? DEV_API_BASE : PRODUCTION_API_BASE // this is a manaul toggle variable

// fetch data from gonation and sets it to component state.
export default async (gonationID, displayAlbums) => {
  return await axios({
    url: `${APIBASE}/profile/gallery?profile_id=${gonationID}`,
    adapter: jsonpAdapter
  }).then(res => {
    // checks for albums you want to remove if any else use all albums.
    const albumList = displayAlbums ? filterAlbums(res.data, displayAlbums) : res.data
    return albumList
    //   setGalleryData({ ...galleryData, albums: albumList, isLoading: false })
  })
}
